import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-450d0b0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "media/icons/duotune/communication/com006.svg"
  })
], -1))
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "menu-item px-5"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" My Account ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1))
const _hoisted_12 = { class: "menu-item px-5 my-1" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.user.last_name) + " " + _toDisplayString(_ctx.user.first_name), 1),
          _createElementVNode("a", {
            href: "#",
            class: "fw-bold text-muted text-hover-primary fs-7 email-overflow",
            title: _ctx.user.email
          }, _toDisplayString(_ctx.user.email), 9, _hoisted_7)
        ])
      ])
    ]),
    _hoisted_8,
    (_ctx.user.user_type !== 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: _ctx.profileUrl,
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("a", {
        href: _ctx.mrbUrlContact,
        target: "_blank",
        class: "menu-link px-5"
      }, " Help ", 8, _hoisted_13)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, " Sign Out ")
    ])
  ]))
}